





































import { Component } from 'vue-property-decorator';

// @ts-ignore
import KUTE from 'kute.js';

import { Gradient } from '@/components/wobble/model';
import Chapter from './Chapter.vue';
import FloatingWobble from '@/components/wobble/FloatingWobble.vue';

@Component({
  components: {
    FloatingWobble,
  }
})
export default class Introduction extends Chapter {
  public wobbleGradient = new Gradient(
    '#E96B10',
    '#FCE417',
    0.2,
    0.8,
    434.0731,
    33.9318,
    47.0534,
    448.9596,
  );

  public textIdx = 0;
  public showText = false;
  public animationDuration = {
    enter: 700,
    leave: 700,
  }

  public timespanPerText = 3300;

  public startColorTween: any;
  public stopColorTween: any;

  public intros = [
    {
      text: 'this space is for you,<br>a place to calm down<br>and take a break.',
      startColor: '#e96b10',
      stopColor: '#fce417',
    },
    {
      text: 'for the next 5 minutes,<br>resolve to let go of any worries.',
      startColor: '#9c33ff',
      stopColor: '#ff9c33',
    },
    {
      text: 'and try to focus entirely<br>on this practice.',
      startColor: '#0500FF',
      stopColor: '#8400D6',
    },
    {
      text: 'to begin, sit or stand comfortably.',
      startColor: '#DF18FF',
      stopColor: '#302CFF',
    },
  ]

  public iterateText() {
    setTimeout(async () => {
      this.showText = false;
      await new Promise(resolve => setTimeout(resolve, this.animationDuration.leave));

      if (this.textIdx < this.intros.length - 1) {
        this.textIdx ++;
        this.startColorTween = KUTE.to(
          '#floating-wobble-gradient-startintro',
          {
            attr: {
              'stop-color': this.intros[this.textIdx].startColor,
            }
          },
          {
            duration: this.timespanPerText / 2,
            easing: 'easingSinusoidalInOut',
          }
        );
        this.stopColorTween = KUTE.to(
          '#floating-wobble-gradient-stopintro',
          {
            attr: {
              'stop-color': this.intros[this.textIdx].stopColor,
            }
          },
          {
            duration: this.timespanPerText / 2,
            easing: 'easingSinusoidalInOut',
          }
        );
        this.startColorTween.start();
        this.stopColorTween.start();
        this.showText = true;
        await new Promise(resolve => setTimeout(resolve, this.animationDuration.enter));

        this.iterateText();
      } else {
        this.releaseScroll();
        this.goToNextChapter();
      }
    }, this.timespanPerText);
  }

  async chapterActivated() {
    this.lockScroll();
    // Wait a bit so that the user can settle with the screen movement
    await new Promise(resolve => setTimeout(resolve, 1500));
    this.iterateText();
    this.showText = true;
  }
}
